import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M9.75 4.75H6C5.30964 4.75 4.75 5.30964 4.75 6V9.5M9.75 4.75H18C18.6904 4.75 19.25 5.30964 19.25 6V18C19.25 18.6904 18.6904 19.25 18 19.25H9.75M9.75 4.75V9.5M9.75 19.25H6C5.30964 19.25 4.75 18.6904 4.75 18V14.5M9.75 19.25V14.5M9.75 14.5H4.75M9.75 14.5V9.5M4.75 14.5V9.5M9.75 9.5H4.75" />
		<Path d="M17.5 12H14.5M11.5 12H14.5M14.5 12V9M14.5 12V15" />
	</SVG>
);
